import {useEffect, useState, useRef} from "react";
import { UseAPICaller } from "../apiCaller.tsx";
import {StockImage} from "./Brand.tsx";
import { Company } from "../AuthContext";
import AppDialog from "./AppDialog.tsx";
import CompanyInfoDialogContent from "./form/CompanyInfoDialogContent.tsx";
import ActivityDialogContent from "./form/ActivityDialogContent.tsx";
import SurveyDialogContent from "./form/SurveyDialogContent.tsx";
import CreateSurveyDialogContent from "./form/CreateSurveyDialogContent.tsx";
import { DefaultActivity, DefaultReport, ActivitySurveyStatusData } from "./form/FormDataTypes.tsx";

import "../css/Dashboard.css";
import ReportMainDialogContent from "./form/ReportMainDialogContent.tsx";


//TODO: Fix the status windows
function CompanyInfo({companyInfo, editCallback, reportActivityStatus: activitySurveyStatus})
{
    return (
        <div className="dashboard-company-container">
            <div className="dashboard-company-info">
                <div className="info-title">
                    <h1>{companyInfo.companyName}</h1>
                    <div style={{marginLeft:"auto", padding:16}}>
                        <span style={{paddingRight:8}}>Edit:</span>
                        <i 
                            className="fa fa-pencil edit-info" 
                            aria-hidden="true"
                            onClick={editCallback}
                        ></i>
                    </div>
                </div>
                <div className="dashboard-company-info-summary">
                    <div style={{marginTop:16}}>
                        <label>What is you company doing</label>
                        <p>{companyInfo.doing}</p>
                    </div>
                    <div>
                        <label>What is you company solving</label>
                        <p>{companyInfo.solving}</p>
                    </div>
                    <div>
                        <label>Who are you company targeting</label>
                        <p>{companyInfo.target}</p>
                    </div>
                </div>
                <div className="dashboard-company-status">
                    <div className="status white">
                        <h2>{activitySurveyStatus.openActivities}</h2>
                        <p>Open activities</p>
                    </div>
                    <div className="status white">
                        <h2>{activitySurveyStatus.openSurveys}</h2>
                        <p>Open surveys</p>
                    </div>
                    <div className="status red">
                        <h2>{activitySurveyStatus.finishedActivities}</h2>
                        <p>Finished activities</p>
                    </div>
                    <div className="status red">
                        <h2>{activitySurveyStatus.publishedSurveys}</h2>
                        <p>Published surveys</p>
                    </div>
                </div>
            </div>
            {companyInfo.companyImagePath ? <img className="dashboard-company-image" src={`http://185.7.62.58/${companyInfo.companyImagePath}`} alt="Image"></img> : <span>No company image uploaded</span>}
        </div>
    );
}


function Reports({reports, OnCreateNewReport, dialogCallback})
{
    return (
        <div className="report-container">
            <div className="report-item" style={{justifyContent:"center"}}>
                <i 
                    className="fa fa-plus-circle create-new-button" 
                    aria-hidden="true" 
                    onClick={() => OnCreateNewReport()}
                ></i>
                <h2>New Report</h2>
            </div>
            {reports.map(item => (
                <div key={item.id} className="report-item">
                    {item.thumbnailPath ? <img className="report-thumbnail" src={`http://185.7.62.58:5000/${item.thumbnailPath}`} alt="Image"></img> : <span>No cover image</span>}
                    <div>
                        <h2>{item.title}</h2>
                    </div>
                    <div className="item-function">
                        <button onClick={() => dialogCallback(item.id)} style={{backgroundColor:"#000F9F"}}>View</button>
                    </div>
                </div>
            )).reverse()}
        </div>
    );
}


function Activities({activities, OnCreateNewActivity, dialogCallback})
{
    return(
        <div className="activity-container">
            <div className="activity-item" style={{justifyContent:"center"}}>
                <i 
                    className="fa fa-plus-circle create-new-button" 
                    aria-hidden="true" 
                    onClick={() => OnCreateNewActivity()}
                ></i>
                <h2>New Activity</h2>
            </div>
            {activities.map(item => (
                <div key={item.id} className="activity-item">
                    <h2 >{item.title}</h2>
                    {item.thumbnailPath ? <img className="activity-thumbnail" src={`http://185.7.62.58:5000/${item.thumbnailPath}`} alt="Image"></img> : <span>No cover image</span>}
                    <p style={{textOverflow:"ellipsis", flexGrow:"1", overflow:"hidden"}}>{item.description}</p>
                    <div className="item-function">
                        <button onClick={() => {dialogCallback(item.id)}} style={{backgroundColor:`${item.finished ? "#17A0E4" : "#000F9F"}`}}>{item.finished ? "View" : "Edit"}</button>
                    </div>
                </div>
            )).reverse()}
        </div>
    );
}


function Surveys({surveys, SurveyCreateDialogCallback, SurveyDialogCallback})
{
    return(
        <div style={{justifyItems:"center"}}>
            <div  className="survey-container">
                <div className="survey-card">
                    <span style={{color:"#003399", fontSize:"larger", fontWeight:"bold"}}>Title</span>
                    <span style={{color:"#003399", fontSize:"larger", fontWeight:"bold"}}>Responses</span>
                    <span style={{color:"#003399", fontSize:"larger", fontWeight:"bold"}}>Published</span>
                    <span style={{color:"#003399", fontSize:"larger", fontWeight:"bold"}}>Open</span>
                </div>
                <hr></hr>
            </div>
            <div className="survey-container">
                {surveys.map(item => (
                    <div key={item.id} className="survey-card">
                        <span style={{fontWeight:"bold", textOverflow:"ellipsis"}}>{item.title}</span>
                        <span>{item.numResponses}</span>
                        {item.published ? 
                            (<i className="fa fa-check" aria-hidden="true" style={{color:"green"}}></i>) : 
                            (<i className="fa fa-times" aria-hidden="true" style={{color:"red"}}></i>)
                        }
                        {item.active ? 
                            (<i className="fa fa-check" aria-hidden="true" style={{color:"green"}}></i>) : 
                            (<i className="fa fa-times" aria-hidden="true" style={{color:"red"}}></i>)
                        }
                        <button onClick={() => SurveyDialogCallback(item.id)} style={{backgroundColor:`${(item.active || item.published) ? "#17A0E4" : "#000F9F"}`}}>{(item.active || item.published) ? "View" : "Edit"}</button>
                    </div>
                )).reverse()}
            </div>
            <div style={{display:"flex", justifyContent:"center"}}>
                <i 
                    className="fa fa-plus-circle create-new-button" 
                    aria-hidden="true" 
                    onClick={() => SurveyCreateDialogCallback()}
                    style={{paddingTop:"2rem", paddingBottom:"4rem"}}
                ></i>
            </div>
        </div>
    );
}


function DashboardHeader({title, description, refName})
{
    return (
        <div ref={refName} className="dashboard-header">
            {/* <KBTLogo size={150} /> */}
            <div className="dashboard-header-title">
                <h1>{title}</h1>
                {/* <p>{description}</p> */}
            </div>
        </div>
    );
}


function Dashboard()
{
    document.body.classList.remove("SignIn-page");

    // const {GetActivities, GetCompanyInfoFromId, GetReports, GetSurveys, CreateNewSurvey, GetSurveyPublishedStatus, CreateNewReport, CreateNewActivity, GetReportActivityStatus} = UseJsonApi();
    const {GetCompanyInfo, GetReports, CreateNewReport, GetActivities, CreateNewActivity, GetSurveys, CreateNewSurvey, GetActivitySurveyStatus} = UseAPICaller();

    const [reports, setReports] = useState([]);
    const [activities, setActivities] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [company, setCompany] = useState<Company>({companyId:0, companyName:""});
    const [companyInfo, setCompanyInfo] = useState({});
    const [reportActivityStatus, setReportActivityStatus] = useState<ActivitySurveyStatusData>({openSurveys:0, openActivities:0,publishedSurveys:0,finishedActivities:0});

    const [dialogType, setDialogType] = useState<"report"|"activity"|"survey"|"surveyEdit"|"company"|"none">("none");


    const reportRef = useRef<HTMLDivElement>(null);
    const activityRef = useRef<HTMLDivElement>(null);
    const surveyRef = useRef<HTMLDivElement>(null);

    const GetReportsFromDB = async (companyId:number) => 
    {
        const reportsFromDB = await GetReports(companyId);
        setReports(reportsFromDB);
    };

    const GetActivitiesFromDB = async (companyId:number) => 
    {
        const activitesFromDB = await GetActivities(companyId);
        setActivities(activitesFromDB);
    };

    const GetSurveysFromDB = async (companyId:number) => 
    {
        const surveysFromDB = await GetSurveys(companyId);
        setSurveys(surveysFromDB);
    };

    const GetActivitySurveyStatusFromDB = async (companyId:number) => {
        const status = await GetActivitySurveyStatus(companyId);
        if(status)
            setReportActivityStatus(status);
    }

    //Run once when the page loads
    useEffect( () => 
    {
        const company = JSON.parse(sessionStorage.getItem("company"));
        
        const GetCompanyInfoFromDB = async () => 
        {
            const companyInfo = await GetCompanyInfo(company.companyId);
            setCompanyInfo(companyInfo);
        };
        setCompany(company);

        GetCompanyInfoFromDB();

        GetReportsFromDB(company.companyId);
        GetActivitiesFromDB(company.companyId);
        GetSurveysFromDB(company.companyId);
        GetActivitySurveyStatusFromDB(company.companyId);
    }, []);


    const ActivityDialogCallback = (id:number) => {
        sessionStorage.setItem("activityId", id.toString());
        setDialogType("activity");
    }
    const ReportDialogCallback = (id:string) => {
        sessionStorage.setItem("reportId", id);
        setDialogType("report");
    }
    //TODO:Fix with better popup
    const SurveyCreateDialogCallback = async () => {
        let surveyTitle = prompt("Create new survey.", "Survey Title");
        if (surveyTitle != null && surveyTitle != "") {
            await CreateNewSurvey(surveyTitle, company.companyId);

            const surveysFromDB = await GetSurveys(company.companyId);
            setSurveys(surveysFromDB);
        }
    };
    async function SurveyDialogCallback(surveyId:number) 
    {
        const isPublished = surveys.find(item => item.id === surveyId).published;  
        if (isPublished) 
            SurveyStatusDialogCallback(surveyId);
        else
            SurveyEditDialogCallback(surveyId);
    };
    const SurveyEditDialogCallback = (surveyId:number) => {
        sessionStorage.setItem("surveyId", surveyId.toString());
        setDialogType("surveyEdit");
    };
    const SurveyStatusDialogCallback = (surveyId:number) => {
        sessionStorage.setItem("surveyId", surveyId.toString());
        setDialogType("survey");
    };
    const OnDialogClose = () => {
        sessionStorage.removeItem("reportId");
        sessionStorage.removeItem("activityId");
        sessionStorage.removeItem("surveyId");
        
        GetActivitySurveyStatusFromDB(company.companyId);
        setDialogType("none");
        window.location.reload();
    }

    const OnCreateNewReport = async () => {
        const response:DefaultReport = await CreateNewReport(company.companyId);
        if(response)
        {
            ReportDialogCallback(response.id);
        }
    };
    const OnCreateNewActivity = async () => {
        const response = await CreateNewActivity(company.companyId);
        if(response)
        {
            ActivityDialogCallback(response.activityId);
        }
    };

    const ScrollToSection = (ref : React.RefObject<HTMLDivElement>) => {
        ref.current?.scrollIntoView({behavior:"smooth"});
    }

    const GoToGamma = () => {
        window.open("https://gamma.app", "_blank");
    }

    return (
        <div className="dashboard-bg">
            <CompanyInfo 
                companyInfo={companyInfo} 
                editCallback={() => setDialogType("company")}
                reportActivityStatus={reportActivityStatus}
            />
            <div className="dashboard-navbar">
                <button className="dashboard-navboard-button" onClick={() => ScrollToSection(surveyRef)}>Surveys <i className="fa fa-arrow-down"></i></button>
                <button className="dashboard-navboard-button" onClick={() => ScrollToSection(activityRef)}>Activities <i className="fa fa-arrow-down"></i></button>
                <button className="dashboard-navboard-button" onClick={() => ScrollToSection(reportRef)}>Reports <i className="fa fa-arrow-down"></i></button>
                <button className="dashboard-navboard-button" onClick={GoToGamma}>To GAMMA <i className="fa fa-picture-o"></i></button>
            </div>
            <div>
                <AppDialog 
                isOpen={dialogType !== "none"} 
                OnClose={OnDialogClose}
                title={
                    dialogType === "report" ? "Report" : dialogType === "activity" ? "Activity" : dialogType === "survey" ? "View Survey" : dialogType === "surveyEdit" ? "Edit Survey" : dialogType === "company" ? "Company Info" : "" 
                }
                >
                    {dialogType === "company" && <CompanyInfoDialogContent isOpen={true}/>}
                    {dialogType === "report" && <ReportMainDialogContent isOpen={true}/>}
                    {dialogType === "activity" && <ActivityDialogContent isOpen={true}/>}
                    {dialogType === "surveyEdit" && <CreateSurveyDialogContent isOpen={true}/>}
                    {dialogType === "survey" && <SurveyDialogContent isOpen={true}/>}
                </AppDialog>
            </div>
            <DashboardHeader title={"Reports"} description={"Lorem Ipsum"} refName={reportRef}/>
            <Reports reports={reports} OnCreateNewReport={OnCreateNewReport} dialogCallback={ReportDialogCallback}/>
            <DashboardHeader title={"Activities"} description={"Lorem Ipsum"} refName={activityRef}/>
            <Activities activities={activities} OnCreateNewActivity={OnCreateNewActivity} dialogCallback={ActivityDialogCallback}/>
            <DashboardHeader title={"Surveys"} description={"Lorem Ipsum"} refName={surveyRef}/>
            <Surveys surveys={surveys} SurveyCreateDialogCallback={SurveyCreateDialogCallback} SurveyDialogCallback={SurveyDialogCallback}/>
            <div className="dashboard-footer">
                <div style={{width:"100%", height:24, backgroundColor:"#003399"}}></div>
                {/* <hr></hr> */}
                <img src="/images/logosFooter.png" alt="footer" style={{width:"100%", marginTop:24}}/>;
            </div>
        </div>
    );
}

export default Dashboard;

const TMP_CONTENT = "Annual Report: Community Activities & Surveys (2024) Over the past year, four major activities were organized with the goal of fostering creativity, collaboration, and cultural exchange. Participation levels and survey feedback show strong community engagement and positive outcomes. Activities - Global Game Jam (January 28) – 120 participants - Spring Hackathon (April 14) – 42 participants - Creative Jam (August 30) – 13 participants - Autumn Design Camp (October 18) – 65 participants Survey Feedback Surveys were distributed after each event, with over 75% response rates. Results are summarized below: - Enjoyment: 88% reported they “enjoyed the event a lot” - Return Intention: 82% said they would attend again - Recommendation: 85% would recommend the event to others - Organization Quality: 79% rated the organization as “very good” or “excellent” Key Insights - Larger events like the Global Game Jam drew wide attention and had the highest visibility. - Smaller events such as the Creative Jam still provided meaningful networking and collaboration opportunities, despite limited attendance. - Survey responses confirm a high degree of satisfaction across all events, with clear potential to expand participation in the coming year. Conclusion 2024’s activities successfully engaged a diverse group of participants, strengthened the municipality’s creative community, and demonstrated strong support for continued investment in cultural and collaborative events."; 